import { render } from "./hobbies.vue?vue&type=template&id=2d3453c2"
import script from "./hobbies.vue?vue&type=script&lang=js"
export * from "./hobbies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__